import React from 'react';
import empty_state from '../../../src/assets/images/empty-state.png';

const EmptyData = ({ title, subTitle }) => {
  return (
    <div className="empty-data-chart w-100 d-flex flex-column align-items-center justify-content-center">
      <div className="chart-head">
        <p className="chart-head__title">{title && title}</p>
        <p className="chart-head__subtitle">{subTitle && subTitle}</p>
      </div>
      <div className="chart-image">
        <img src={empty_state} />
      </div>
      <div className="chart-footer">
        <p>Mohon maaf, data kendaraan yang Anda cari tidak ditemukan.</p>
        <p>Anda dapat menemukan data kendaraan lainnya dengan mengubah pencarian sesuai yang diinginkan.</p>
      </div>
    </div>
  );
};

export default EmptyData;
